import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { AppCommonModule } from '@root/common/app-common.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';

import { processRequest } from '../app/utils/process-request';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { ComponentsModule } from './components/components.module';
import { CatalogueModule } from './components/catalogue/catalogue.module';
import { AngularEditorModule } from '@kolkov/angular-editor';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    AngularFontAwesomeModule,
    BrowserAnimationsModule,
    FormsModule,
    NgbModalModule,
    ComponentsModule,
    CatalogueModule,
    AngularEditorModule,
    AppCommonModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
    }),
  ],
  entryComponents: [],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: processRequest,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
